import { AuthProvider } from 'react-oidc-context'
import userManager from './userManager'
import OidcReduxScopeBridge from './OidcReduxScopeBridge'

// Strips the OIDC `code`/`state` query params from the URL once the
// Authorization Code + PKCE callback has been processed, so a page refresh
// doesn't try to replay the same authorization code.
function onSigninCallback() {
    window.history.replaceState({}, document.title, window.location.pathname)
}

// The app's auth path (see docs/specs/0001-oidc-migration.md, ADR-0001). Wraps
// the app in react-oidc-context's AuthProvider, configured against the
// backend's Authorization Server. Passes the shared userManager singleton
// (rather than spreading oidcConfig as settings) so the axios interceptor
// reads the exact same session state. OidcReduxScopeBridge mirrors that
// session's Scopes into Redux for the ticket-07 authorization selectors.
function OidcAuthBoundary({ children }) {
    return (
        <AuthProvider userManager={userManager} onSigninCallback={onSigninCallback}>
            <OidcReduxScopeBridge>{children}</OidcReduxScopeBridge>
        </AuthProvider>
    )
}

export default OidcAuthBoundary
